import { Trans, useTranslation } from 'react-i18next';

import Photo from '../Photo';
import Stat from '../Stat';
import { getListingById } from '../../data/listings';

export default function Hero() {
  const { t } = useTranslation();
  // photos[2] === 02-lounge-3: open-plan dining table with pendants + bookcase.
  const heroPhoto = getListingById('fourways')?.photos[2];

  return (
    <section
      id="top"
      className="relative grid min-h-screen items-end gap-14 px-6 pb-24 pt-32 md:grid-cols-[1.1fr_0.9fr] md:gap-14 md:px-10 md:pb-16 md:pt-36"
    >
      <div>
        <div className="mb-9 inline-flex items-center gap-2.5 rounded-full border border-line bg-surface/50 px-3.5 py-1.5 text-xs uppercase tracking-[0.08em] text-muted">
          <span className="h-1.5 w-1.5 rounded-full bg-accent2" />
          {t('hero.eyebrow')}
        </div>
        <h1 className="m-0 text-balance font-display font-semibold leading-[0.95] tracking-display text-ink [font-size:clamp(56px,8vw,124px)]">
          <Trans
            i18nKey="hero.headline"
            components={{ break: <br />, em: <em className="font-[inherit] not-italic text-accent italic" /> }}
          />
        </h1>
        <p className="mt-8 max-w-[520px] text-pretty text-[18px] leading-[1.55] text-muted">
          {t('hero.subhead')}
        </p>
        <div className="mt-10 flex flex-wrap gap-3.5">
          <a
            href="#stays"
            className="inline-flex items-center gap-2.5 rounded-full border border-transparent bg-accent px-7 py-4 text-[15px] font-medium text-white no-underline transition hover:brightness-105"
          >
            {t('hero.ctaPrimary')} <span aria-hidden>→</span>
          </a>
          <a
            href="#principles"
            className="inline-flex items-center rounded-full border border-line bg-surface px-7 py-4 text-[15px] font-medium text-ink no-underline transition hover:bg-surface/70"
          >
            {t('hero.ctaSecondary')}
          </a>
        </div>
      </div>

      <div className="relative">
        <div className="overflow-hidden rounded-xs xl:max-h-[calc(100svh-13rem)]">
          {heroPhoto && (
            <Photo
              photo={heroPhoto}
              alt={t('hero.imageLabel')}
              ratio="4/5"
              sizes="(min-width: 1280px) 45vw, (min-width: 768px) 50vw, 100vw"
              loading="eager"
              priority="high"
            />
          )}
        </div>
        <div className="absolute bottom-5 left-5 max-w-[240px] rounded-xs border border-line bg-surface px-4 py-3.5 text-sm text-ink shadow-2xl">
          <div className="mb-0.5 font-display text-[15px] font-semibold">{t('hero.bookingCardTitle')}</div>
          <div className="text-muted">{t('hero.bookingCardCopy')}</div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-x-6 gap-y-3 text-[13px] text-muted md:absolute md:inset-x-10 md:bottom-6 md:flex md:flex-wrap md:justify-between md:gap-6">
        {(['power', 'water', 'support', 'estates'] as const).map((k) => (
          <Stat key={k} label={t(`hero.stats.${k}.label`)} value={t(`hero.stats.${k}.value`)} />
        ))}
      </div>
    </section>
  );
}
